import * as React from 'react';

const Clock24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.25 7.75a.75.75 0 0 1 1.5 0v3.375a1 1 0 0 0 .4.8l2.7 2.025a.75.75 0 1 1-.9 1.2l-3.3-2.475a1 1 0 0 1-.4-.8z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M2.5 12a9.5 9.5 0 1 0 19 0 9.5 9.5 0 0 0-19 0"
  }
));
Clock24.Size = 24;
Clock24.Title = "Clock";

export { Clock24 as default };
